<template>
    <div class="swiper-container">
        <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
                <Header class="header-wrap"></Header>
                <div class="banner-box">
                    <el-carousel
                        height="100vh"
                        :interval="5000"
                        :autoplay="true"
                        arrow="never"
                        ref="carousel"
                        indicator-position="none"
                    >
                        <el-carousel-item
                            ref="bannerImg"
                            v-for="(item, i) in bannerLists"
                            :key="i"
                        >
                            <img
                                class="img"
                                @click="handleBannerDetail(item)"
                                :src="item.picUrl"
                            />
                        </el-carousel-item>
                    </el-carousel>
                    <div class="custom-indicators">
                        <div
                            v-for="(item, index) in bannerLists"
                            :key="index"
                            class="indicator"
                            :class="{ active: activeIndex === index }"
                            @click="handleIndicatorClick(index)"
                        >
                            <img
                                :src="
                                    activeIndex === index
                                        ? activeIndicatorImage
                                        : indicatorImage
                                "
                                alt="indicator image"
                                class="indicator-image"
                            />
                        </div>
                    </div>
                    <ScrollNotice></ScrollNotice>
                </div>
            </swiper-slide>
            <swiper-slide class="box2-wrap">
                <div class="box2-wrap-content" v-if="swiperIndex === 1">
                    <img  src="/image/BANNER002.png" alt="" />
                </div>
                <img 
                    v-if="swiperIndex === 1"
                    class="banner-zi"
                    ref="bannerZi"
                    src="/image/bannerzi.png"
                    alt="" />
                <!-- <img v-if="swiperIndex === 1"
                     style="width: 100%;height: 100%;"
                     src="/image/page2.png"
                     alt="" /> -->
                <!-- <div class="box2">
                    <img src="@/assets/imgs/21@2x.png" alt="" />
                </div>
                <div class="soide-line"></div> -->
                <!-- <p class="box2-text">
                    大圣文化的溯源、传承、交流、弘扬四个部分，诉说大圣文化的古往今来，带领观众朋友穿越时空，
                    探索大圣文化的传承与发展，以及与现实相适应的时代精神，顺昌大圣文化发展至今，
                    已成为新时代中华优秀传统文化创造性转化和创新性发展的生动案例。
                </p> -->
                <!-- <div class="box2-imgs"> -->
                <!-- <img v-if="swiperIndex === 1"
                         class="img1 animate__animated animate__fadeInLeft"
                         src="@/assets/imgs/5@2x.png"
                         alt="" />
                    <img v-if="swiperIndex === 1"
                         class="img2 animate__animated animate__fadeInUpBig"
                         src="/image/bw.png"
                         alt="" />
                    <img v-if="swiperIndex === 1"
                         class="img3 animate__animated animate__fadeInRight"
                         src="/image/ds.png"
                         alt="" /> -->
                <!-- </div> -->
            </swiper-slide>
            <swiper-slide class="box3-wrap">
                <ul>
                    <li class="trans1" @click="handleJt(1)">
                    </li>
                    <li class="trans2" @click="handleJt(2)">
                    </li>
                    <li class="trans3" @click="handleJt(3)">
                    </li>
                    <li class="trans4" @click="handleJt(4)">
                    </li>
                </ul>
            </swiper-slide>
            <swiper-slide class="box4-wrap">
                <div class="box4">
                    <img src="@/assets/imgs/43@2x.png" alt="" />
                </div>
                <!-- map组件 -->
                <div class="map-wrap">
                    <mapComponent></mapComponent>
                </div>
            </swiper-slide>
            <swiper-slide class="box5-wrap">
                <div class="box5-left">
                    <div>
                        <img
                            @click="gotoTravelColumn"
                            class="title"
                            src="@/assets/imgs/32@2x.png"
                            alt=""
                        />
                        <div class="content"><img :src="hoverPicLy" alt="" /></div>
                    </div>
                </div>
                <div class="box5-right">
                    <div>
                        <!-- 多条内容卡片 -->
                        <div
                            class="card"
                            v-for="(item, index) in dataList"
                            :key="index"
                            @mouseenter="hoverPicLy = item.picUrl"
                            @click="handleCardClickTrave(item)"
                        >
                            <div class="card-line"></div>
                            <div class="card-content">
                                <div class="title">
                                    <span>{{ item.title }}</span>
                                </div>

                                <!-- 内容描述 + 发布时间 -->
                                <div class="card-bottom line1">
                                    {{ item.introduction }}
                                    <label class="date">{{ item.date }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="box6-wrap">
                    <div class="box6">
                        <img src="@/assets/imgs/16@2x.png" alt="" />
                    </div>
                    <div class="container">
                        <div
                            class="card"
                            v-for="(item, index) in cards"
                            :key="index"
                            @click="handleCardClick(item)"
                        >
                            <div class="card-icon">
                                <img :src="item.img" alt="" />
                            </div>
                            <div class="card-title">{{ item.title }}</div>
                            <!-- <div class="vertical-dotted"></div>
                <div class="card-count"><i>{{ item.count }}</i>人已参加</div> -->
                        </div>
                    </div>
                    <!-- <img class="bg-left" src="@/assets/imgs/40@2x.png" alt="">
            <img class="bg-right" src="@/assets/imgs/41@2x.png" alt=""> -->
                </div>
                <Footers></Footers>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
    </div>
</template>

<script setup>
// 响应式状态
import { onMounted, reactive, ref, toRefs, computed, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import {
    articleLists,
    classification,
    antiqueLists,
    getHomeBanner,
    getActivityLists,
    getEbookLists
} from '@/api/index';
import moment from 'moment';
import RankBox from '@/components/rankBox.vue';
import useGoDetail from '@/minixs/goDetail';

import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'; // 导入Swiper的所有CSS样式
import Footers from '@/components/footer.vue';
import Header from '@/components/header.vue';
import mapComponent from '@/components/mapComponent.vue';
import ScrollNotice from '@/components/scrollNotice.vue';

const router = useRouter();
const swiperIndex = ref(0);
const state = reactive({
    culturalRelic: 1,
    zxLists: [],
    wwLists: [],
    active: {},

    bannerLists: [],
    commendLists: [],
    rankLists: [],

    swiperOption: {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        mousewheel: true,
        direction: 'vertical',
        on: {
            slideChange: function () {
                swiperIndex.value = this.activeIndex;
            }
        }
    },
    activeIndex: 0,
    indicatorImage: require('@/assets/imgs/20.png'),
    activeIndicatorImage: require('@/assets/imgs/19.png'),
    dataList: [],
    cards: [
        {
            icon: '专题知识库图标路径',
            title: '专题知识库',
            count: '250',
            img: require('@/assets/imgs/35@2x.png'),
            url: '/literatureLecture?index=0'
        },
        {
            icon: '知识问答图标路径',
            title: '知识问答',
            count: '250',
            img: require('@/assets/imgs/37@2x.png'),
            url: '/literatureLecture?index=1'
        },
        {
            icon: '在线评测图标路径',
            title: '在线评测',
            count: '250',
            img: require('@/assets/imgs/39@2x.png'),
            url: '/literatureLecture?index=2'
        }
    ]
});
const hoverPicLy = ref(null);
const carousel = ref();
const handleIndicatorClick = (index) => {
    state.activeIndex = index;
    carousel.value.setActiveItem(index);
};

// 跳转资讯
const handleZX = () => {
    router.push('/information');
};
// 跳转资讯详情
const handleZxDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/information/detail?id=' + item.id);
    }
};

const goNextPage = (url) => {
    router.push(url);
};

// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: 1,
        pageSize: 6,
        categoryId: 4
    }).then(({ data }) => {
        const _data = data?.list || [];
        hoverPicLy.value = _data[0]?.picUrl;
        _data.forEach((element) => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        state.dataList = _data;
    });
};

/** 详情页的跳转 使用 mixin 的跳转方法**/
const { handleDetail } = useGoDetail();

const bannerImg = ref(null);
const getBanner = () => {
    getHomeBanner({ position: 1 }).then(({ data }) => {
        state.bannerLists = data;
    });
};

const handleBannerDetail = (item) => {
    router.push(item.url);
};
const handleJt = (index) => {
    switch (index) {
        case 1:
            router.push('/dsCulture?id=8');
            break;
        case 2:
            router.push('/dsCulture?id=9');
            break;
        case 3:
            router.push('/dsCulture?id=10');
            break;
        case 4:
            router.push('/dsCulture?id=11');
            break;
    }
};

const handleCardClick = (item) => {
    router.push(item.url);
};

const handleCardClickTrave = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/literatureLecture/detail?id=' + item.id + '&categoryId=' + 4);

    }
};

const gotoTravelColumn = () => {
    router.push('/travelColumn');
};


const {
    zxLists,
    wwLists,
    culturalRelicLists,
    culturalRelic,
    bannerImgHeight,
    active,
    bannerLists,
    commendLists,
    rankLists,
    swiperOption,
    activeIndex,
    indicatorImage,
    activeIndicatorImage,
    dataList,
    cards
} = toRefs(state);

// 生命周期钩子
onMounted(() => {
    getZxLists();
    getBanner();
    
});

</script>

<style lang="scss" scoped>
.swiper-container {
    width: 100%;
    height: 100vh;
}

.slide-content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #fff;
    background-color: #007aff;
    height: 100%;
}

.swiper-pagination-bullet {
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    color: #000;
    opacity: 1;
    background: rgba(0, 0, 0, 0.2);
}

.swiper-pagination-bullet-active {
    color: #fff;
    background: #007aff;
}
.header-wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
.banner-box {
    height: 100%;
    position: relative;
    .img {
        width: 100%;
        height: 100%;
    }
}
.carousel-container {
    position: relative;
    width: 100%;
    height: 400px;
}

.el-carousel__container {
    height: 100%;
}

.carousel-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.custom-indicators {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 9;
}

.indicator {
    cursor: pointer;
    border-radius: 50%;
    overflow: hidden;
    transition: transform 0.3s ease;
}

.indicator:hover {
    transform: scale(1.1);
}

.indicator.active {
    transform: scale(1.2);
}

.indicator-image {
    width: 24px;
    height: 22px;
}
.box2-wrap {
    box-sizing: border-box;
    // padding-top: 145px;
    position: relative;
    .box2-wrap-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 0;
        img {
            transform: translateX(calc(-100% + 100vw));
            animation: bannerZi 4s;
        }
    }
    .banner-zi {
        position: absolute;
        top: 150px;
        left: 50%;
        transform: translateX(-50%);
        width: 550px;
        animation: bannerZi2 4s;
    }
    @keyframes bannerZi {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(calc(-100% + 100vw));
        }
    }
    @keyframes bannerZi2 {
        0% {
            top: 300px;
            opacity: 0;
        }
        100% {
            top: 150px;
            opacity: 1;
        }
    }
}
.box3-wrap {
    display: flex;
    .box3-left {
        background: #72a19c;
        width: 318px;
        height: 100%;
        text-align: center;
        display: flex; // 新增
        align-items: center; // 新增
        justify-content: center; // 新增
        img {
            width: 100%;
            height: 100%;
            object-fit: cover
        }
    }
    ul {
        width: 100%;
        display: flex;
        .trans1 {
            background-image: url("~@/assets/imgs/ds/hover1.png") !important;
        }
        .trans2 {
            background-image: url("~@/assets/imgs/ds/hover2.png") !important;
        }
        .trans3 {
            background-image: url("~@/assets/imgs/ds/hover3.png") !important;
        }
        .trans4 {
            background-image: url("~@/assets/imgs/ds/hover4.png") !important;
        }
        li {
            // flex: 1;
            width: 33.33%;
            position: relative;
            display: flex; // 新增
            align-items: center; // 新增
            transition: width 0.4s;
            cursor: pointer;
            background-position: left;
            background-size: cover;
            &:hover {
                width: 55%;
                // background-position: center;
            }

            img {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: -1;
            }
            p {
                writing-mode: vertical-rl;
                position: relative;
                left: 12.5%;
                text-align: center;
                letter-spacing: 2px;
                color: #fff;
                font-weight: 700;
                color: #fdfdf6;
                font-size: 32px;
                transition: left 0.5s, margin 0.3s;
            }
        }
    }
}
.box4-wrap {
    background: url("~@/assets/imgs/3@3x.png");
    background-size: cover;
    .box4 {
        padding-top: 54px;
        text-align: center;
        img {
            width: 190px;
            height: 46px;
        }
    }
}
.box5-left {
    background: url("~@/assets/imgs/2@3x.png");
    background-size: cover;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    float: left;
    > div {
        display: flex;
        align-items: center;
    }
    .title {
        width: 32px;
        height: 422px;
        margin-right: 100px;
        display: inline-block;
    }
    .content {
        background: url("~@/assets/imgs/31@2x.png") no-repeat;
        width: 389px;
        height: 671px;
        background-size: contain;
        padding: 47px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
           width: 390px;
           height: 670px;
           object-fit: cover;
        }
    }
}
.box5-right {
    background: #e6e6e6;
    width: 50%;
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 13px;
    box-sizing: border-box;
    > div {
        width: 100%;
    }

    /* 内容卡片样式 */
    .card {
        margin-bottom: 40px;
        padding: 10px;
        border-radius: 4px;
        display: flex;
        cursor: pointer;
        .card-line {
            width: 100px;
            position: relative;
            margin-right: 10px;
            top: 6px;
            background-image: url("~@/assets/imgs/27@2x.png");
            background-repeat: no-repeat;
            background-size: 97px 19px;
            img {
                width: 97px;
                height: 19px;
            }
        }

        .card-content {
            flex: 1;
            .card-bottom {
                color: #848484;
                font-size: 18px;
                border-bottom: 1px dotted #707070;
                padding-bottom: 9px;
            }
        }
        &:hover {
            .title {
                color: #0b5d69 !important;
            }
            .card-bottom {
                color: #0b5d69 !important;
            }
            .date {
                color: #0b5d69 !important;
            }
            .card-line {
                background-image: url("~@/assets/imgs/26@2x.png") !important;
            }
        }
    }

    /* 内容标题样式 */
    .title {
        color: #232323;
        font-size: 24px;
        margin-bottom: 22px;
    }

    /* 发布时间样式 */
    .date {
        float: right;
        color: #999999;
    }
}
.box6-wrap {
    height: calc(100vh - 133px);
    background-image: url("~@/assets/imgs/10@3x.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    background-position: center;
    .box6 {
        text-align: center;
        padding-top: 61px;
        img {
            width: 190px;
            height: 94px;
        }
    }
    .container {
        display: flex;
        justify-content: space-between;
        margin: 170px auto;
        width: 1000px;
    }

    .card {
        width: 250px;
        height: 250px;
        border-radius: 10px;
        transition: all 0.3s ease;
        text-align: center;
        cursor: pointer;
    }

    .card:hover {
        transform: scale(1.05);
    }

    .card-icon img {
        width: 206px;
        height: 204px;
        margin-bottom: 10px;
    }

    .card-title {
        color: #fdfdf6;
        font-size: 25px;
        text-align: center;
    }
    .card-count {
        width: 120px;
        height: 30px;
        border: 1px solid;
        border-color: #bdebeb;
        color: #fdfdf6;
        font-size: 14px;
        text-align: center;
        margin: 0 auto;
        line-height: 30px;
        i {
            font-style: normal;
            color: #e27443;
        }
    }

    .vertical-dotted {
        width: 0px;
        height: 117px; // 高度自定义
        border-left: 2px dotted #fff;
        margin: 18px auto;
        background: #007aff;
    }
    .bg-left {
        opacity: 0.6;
        width: 448px;
        height: 613px;
        position: absolute;
        left: -224px;
        top: 20%;
        bottom: 0;
        z-index: 9;
    }
    .bg-right {
        opacity: 0.6;
        position: absolute;
        right: -375px;
        top: 20%;
        bottom: 0;
        z-index: 9;
        width: 755px;
        height: 755px;
    }
}
.map-wrap {
    margin-top: 50px;
}
</style>
